import {
    all,
    fork,
    takeEvery,
    takeLatest,
    takeLeading,
} from 'redux-saga/effects';
import { sliceName } from '../redux/organizationSlice';
import * as Sagas from './saga';

function* watchFetchCompanyInfo() {
    yield takeLeading(
        `${sliceName}/fetchCompanyInfo`,
        Sagas.fetchCompanyInfoSaga
    );
}

function* watchPostConnectGmail() {
    yield takeLatest(
        `${sliceName}/postConnectGmail`,
        Sagas.postConnectGmailSaga
    );
}

function* watchPostConnectOutlook() {
    yield takeLatest(
        `${sliceName}/postConnectOutlook`,
        Sagas.postConnectOutlookSaga
    );
}

function* watchFetchTags() {
    yield takeLeading(`${sliceName}/fetchTags`, Sagas.fetchTagsSaga);
}

function* watchCreateTag() {
    yield takeEvery(`${sliceName}/createTag`, Sagas.createTagSaga);
}

function* watchUpdateTag() {
    yield takeEvery(`${sliceName}/updateTag`, Sagas.updateTagSaga);
}

function* watchDeleteTag() {
    yield takeEvery(`${sliceName}/deleteTag`, Sagas.deleteTagSaga);
}

function* watchCreateRejectReason() {
    yield takeEvery(
        `${sliceName}/createRejectReason`,
        Sagas.createRejectReasonSaga
    );
}

function* watchUpdateRejectReason() {
    yield takeEvery(
        `${sliceName}/updateRejectReason`,
        Sagas.updateRejectReasonSaga
    );
}

function* watchDeleteRejectReason() {
    yield takeEvery(
        `${sliceName}/deleteRejectReason`,
        Sagas.deleteRejectReasonSaga
    );
}

function* watchFetchCompanySettings() {
    yield takeLatest(
        `${sliceName}/fetchCompanySettings`,
        Sagas.fetchCompanySettingsSaga
    );
}

function* watchUpdateCompanySettings() {
    yield takeLatest(
        `${sliceName}/updateCompanySettings`,
        Sagas.updateCompanySettingsSaga
    );
}

function* watchDeleteCompanyMailbox() {
    yield takeLatest(
        `${sliceName}/deleteCompanyMailbox`,
        Sagas.deleteCompanyMailboxSaga
    );
}

export function* organizationsSagas() {
    yield all([
        fork(watchFetchCompanyInfo),
        fork(watchPostConnectGmail),
        fork(watchPostConnectOutlook),
        fork(watchFetchTags),
        fork(watchCreateTag),
        fork(watchUpdateTag),
        fork(watchDeleteTag),
        fork(watchCreateRejectReason),
        fork(watchUpdateRejectReason),
        fork(watchDeleteRejectReason),
        fork(watchFetchCompanySettings),
        fork(watchUpdateCompanySettings),
        fork(watchDeleteCompanyMailbox),
    ]);
}
